const mutations = {
    TEAM_NOMINATION_LOADING: (state) => {
        state.teamnominationStatus = 'loading';
    },
    TEAM_NOMINATION_SUCCESS: (state, teamnomination) => {
        state.teamnominationStatus = 'success';
        // state.teamnominationCart = teamnomination.data;
        Vue.set(state, 'teamnominationCart', teamnomination.data);
    },
    TEAM_NOMINATION_GRADES: (state, grades) => {
        state.teamnominationStatus = 'success';
        // state.teamnominationCart = teamnomination.data;
        Vue.set(state, 'grades', grades.data);
    },
    TEAM_NOMINATION_SEASONS: (state, seasons) => {
        state.teamnominationStatus = 'success';
        // state.teamnominationCart = teamnomination.data;
        Vue.set(state, 'seasons', seasons.data);
    },
    TEAM_NOMINATION_DIVISION_GROUPS: (state, divisiongroups) => {
        state.teamnominationStatus = 'success';
        // state.teamnominationCart = teamnomination.data;
        Vue.set(state, 'divisiongroups', divisiongroups.data);
    },
    TEAM_NOMINATION_DIVISIONS: (state, divisions) => {
        state.teamnominationStatus = 'success';
        // state.teamnominationCart = teamnomination.data;
        Vue.set(state, 'divisions', divisions.data);
    },
    TEAM_NOMINATION_PREFERRED_DIVISIONS: (state, preferreddivisions) => {
        state.teamnominationStatus = 'success';
        // state.teamnominationCart = teamnomination.data;
        Vue.set(state, 'preferreddivisions', preferreddivisions.data);
    },
    TEAM_NOMINATION_NOWAITLIST_DIVISIONS: (state) => {
        state.teamnominationStatus = 'success';

        let pref_divisions = _.filter(state.divisions, ['waitlist', false]);
        let arrPrefDivs = pref_divisions.map(e => ({...e, disabled: false, text: e.text.replace('(SOLD OUT) ', '')}));

        Vue.set(state, 'preferreddivisions', arrPrefDivs);
    },
    TEAM_NOMINATION_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.teamnominationStatus = 'error';
        state.teamnominationErrors.record(errors);
    },
    CLEAR_PAYMENT_ERRORS: (state) => {
        state.paymentStatus = '';
        state.paymentErrors.clear();
    },
    PAYMENT_LOADING: (state) => {
        state.paymentStatus = 'loading';
    },
    PAYMENT_SUCCESS: (state) => {
        state.paymentStatus = 'success';
    },
    PAYMENT_ERROR: (state, err) => {
        let errors=err.error?err.error:{};

        state.paymentStatus = 'error';
        state.paymentErrors.record(errors);
    },
    RESET_STATE: (state) => {
        Object.assign(state, state.initialState());
    }
}

export default mutations
